import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router-dom'

import '@/shared/styles/global.css'
import { router } from '@/routes'
import '@/shared/styles/workspace.css'
import '@/shared/styles/reference.css'
import { queryClient } from '@/lib/query.client'
import { AuthProvider } from '@/core/auth/auth.context'
import { ConnectionProvider } from '@/core/connection/connection.context'
import { ToastProvider } from '@/shared/components/toast'

const root = document.getElementById('root')
if (!root) throw new Error('#root is missing from index.html')

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        {/* AuthProvider registers the API token provider, so it must sit above
            anything that fetches. ConnectionProvider is inside it because its
            query needs the token. */}
        <AuthProvider>
          <ConnectionProvider>
            <RouterProvider router={router} />
          </ConnectionProvider>
        </AuthProvider>
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
)
